import { styled } from '@mui/material/styles';
import Page from 'src/components/Page';
import Layout from 'src/layouts';
import AboutWhat from 'src/sections/about/AboutWhat';
import { HomeHero, HomeTrack, HomeHelp } from 'src/sections/home';

const RootStyle = styled('div')(() => ({
  height: '100%',
}));

HomePage.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function HomePage() {
  return (
    <Page title="Asset Track for Cloud">
      <RootStyle>
        <HomeHero />
        <HomeTrack />
        <HomeHelp />
        <AboutWhat />
      </RootStyle>
    </Page>
  );
}
